export default __webpack_public_path__ + "static/media/news62.96bd6f99.jpg";